import { useState, useEffect } from "react";
import { API_URL } from "../config";
import axios from "axios";
import { showToast } from "../components/toast";

const TicketPopup = ({ isOpen, onClose, onSubmit }) => {
  const token = localStorage.getItem("authToken");

  const [ticketData, setTicketData] = useState({
    ticketCategory: "",
    ticketHeading: "",
    ticketDesc: "",
    ticketImage: "",
  });
  const [loading, setLoading] = useState(false);

  const [dropdownOptions, setDropdownOptions] = useState({
    ticketCategoryList: [],
  });

  // 🔹 Fetch ticket categories from API
  const fetchTicketCategories = async () => {
    try {
      const response = await axios.get(`${API_URL}subscriber/get-template`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data?.success && response.data?.data) {
        setDropdownOptions({
          ticketCategoryList: response.data.data.ticketCategoryList || [],
        });
      }
    } catch (error) {
      console.error("Error fetching ticket categories:", error);
      showToast.error("Failed to load ticket categories");
    }
  };

  useEffect(() => {
    if (isOpen) {
      fetchTicketCategories();
    }
  }, [isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTicketData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const files = e.target.files[0];
    setTicketData((prev) => ({ ...prev, ticketImage: files }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    const success = await onSubmit(ticketData);

    setLoading(false);

    if (success) {
      setTicketData({
        ticketCategory: "",
        ticketHeading: "",
        ticketDesc: "",
        ticketImage: "",
      });
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div
      className="modal fade show"
      style={{ display: "block" }}
      tabIndex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog" style={{ maxWidth: "30rem" }}>
        <div className="modal-content">
          <div className="modal-header">
            <div className="col-md-11">
              <h5 className="modal-title" style={{ fontWeight: "bold" }}>
                Add New Ticket
              </h5>
            </div>
            <button type="button" className="btn btn-default" onClick={onClose}>
              &times;
            </button>
            <div className="clearfix"></div>
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit}>
              <div className="panel-body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <label className="control-label">Type of Ticket</label>
                      <select
                        name="ticketCategory"
                        className="form-control"
                        value={ticketData.ticketCategory}
                        onChange={handleChange}
                      >
                        <option value="">- Select -</option>
                        {dropdownOptions?.ticketCategoryList?.map(
                          (option, index) => (
                            <option key={index} value={option.id}>
                              {option.category_name}
                            </option>
                          )
                        )}
                      </select>
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="form-group">
                      <label className="control-label">Ticket Heading</label>
                      <input
                        type="text"
                        name="ticketHeading"
                        placeholder="Enter Ticket Heading"
                        className="form-control"
                        value={ticketData.ticketHeading}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="col-md-12">
                    <fieldset className="form-group">
                      <label className="form-label semibold">
                        Ticket Description
                      </label>
                      <textarea
                        name="ticketDesc"
                        placeholder="Enter Ticket Description"
                        className="form-control"
                        value={ticketData.ticketDesc}
                        onChange={handleChange}
                      ></textarea>
                    </fieldset>
                  </div>

                  <div className="col-md-12">
                    <fieldset className="form-group">
                      <label className="form-label semibold">
                        Upload Image
                      </label>
                      <input
                        type="file"
                        name="ticketImage"
                        className="form-control"
                        onChange={handleFileChange}
                      />
                      {/* {ticketData.ticketImage && (
                        <div className="mt-2">
                          <img
                            src={URL.createObjectURL(ticketData.ticketImage)}
                            alt="preview"
                            width={100}
                            className="me-2 mb-2"
                          />
                        </div>
                      )} */}
                    </fieldset>
                  </div>

                  {/* Form Buttons */}
                  <div className="col-md-12" style={{ textAlign: "right" }}>
                    <button
                      type="submit"
                      className="btn btn-primary mx-2"
                      disabled={loading}
                    >
                      {loading ? "Submitting..." : "Submit"}
                    </button>

                    <button
                      type="button"
                      className="btn btn-default"
                      onClick={onClose}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TicketPopup;
